function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var NiueFlag = props => /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), {}, {
  children: [/*#__PURE__*/_jsx("mask", {
    id: "mask0_621_2158",
    style: {
      maskType: 'luminance'
    },
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "3",
    width: "24",
    height: "18",
    children: /*#__PURE__*/_jsx("rect", {
      y: "3",
      width: "24",
      height: "18",
      fill: "white"
    })
  }), /*#__PURE__*/_jsxs("g", {
    mask: "url(#mask0_621_2158)",
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M0 3V21H24V3H0Z",
      fill: "#2E42A5"
    }), /*#__PURE__*/_jsx("mask", {
      id: "mask1_621_2158",
      style: {
        maskType: 'luminance'
      },
      maskUnits: "userSpaceOnUse",
      x: "0",
      y: "3",
      width: "24",
      height: "18",
      children: /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 3V21H24V3H0Z",
        fill: "white"
      })
    }), /*#__PURE__*/_jsxs("g", {
      mask: "url(#mask1_621_2158)",
      children: [/*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M0 15V21H24V15H0Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("mask", {
        id: "mask2_621_2158",
        style: {
          maskType: 'luminance'
        },
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "3",
        width: "24",
        height: "12",
        children: /*#__PURE__*/_jsx("rect", {
          y: "3",
          width: "24",
          height: "12",
          fill: "white"
        })
      }), /*#__PURE__*/_jsxs("g", {
        mask: "url(#mask2_621_2158)",
        children: [/*#__PURE__*/_jsx("path", {
          d: "M-1.69666 14.3471L3.06038 15.4476L13.2012 9.84438L14.2743 9.21691L23.9069 4.18017L26.189 2.5894L20.9692 2.108L12.553 6.85551L6.47096 9.84438L-1.69666 14.3471Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          d: "M-1.27875 15.0142L1.28246 15.8543L25.2367 2.3895H21.6404L-1.27875 15.0142Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M25.7781 14.0481L25.967 15.1806L20.9396 15.4475L12.835 10.7005L12.0709 10.9616L-3.06028 3.30798L3.18709 2.10548L11.5391 6.71939L18.0727 9.87634L25.7781 14.0481Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          d: "M25.7954 14.7278L23.2342 15.5679L13.0343 9.80295L10.0102 9.15885L-2.44414 2.59674H1.1521L13.5994 9.00309L16.9057 9.77544L25.7954 14.7278Z",
          fill: "#F50100"
        }), /*#__PURE__*/_jsx("path", {
          d: "M10.2043 2.375V1.75H9.57926V2.375H10.2043ZM10.2043 6.875V7.5H10.8293V6.875H10.2043ZM-0.625 6.875V6.25H-1.25V6.875H-0.625ZM-0.625 11.125H-1.25V11.75H-0.625V11.125ZM10.2043 11.125H10.8293V10.5H10.2043V11.125ZM10.2043 17.125H9.57926V17.75H10.2043V17.125ZM13.8457 17.125V17.75H14.4707V17.125H13.8457ZM13.8457 11.125V10.5H13.2207V11.125H13.8457ZM24.625 11.125V11.75H25.25V11.125H24.625ZM24.625 6.875H25.25V6.25H24.625V6.875ZM13.8457 6.875H13.2207V7.5H13.8457V6.875ZM13.8457 2.375H14.4707V1.75H13.8457V2.375ZM12.5957 6.875V7.5H13.2207V6.875H12.5957ZM12.5957 3.625H13.2207V3H12.5957V3.625ZM11.4543 3.625V3H10.8293V3.625H11.4543ZM11.4543 6.875H10.8293V7.5H11.4543V6.875ZM12.5957 8.125H13.2207V7.5H12.5957V8.125ZM11.4543 8.125V7.5H10.8293V8.125H11.4543ZM12.5957 9.875V10.5H13.2207V9.875H12.5957ZM11.4543 9.875H10.8293V10.5H11.4543V9.875ZM10.2043 8.125H10.8293V7.5H10.2043V8.125ZM0.625 8.125V7.5H0V8.125H0.625ZM0.625 9.875H0V10.5H0.625V9.875ZM10.2043 9.875V10.5H10.8293V9.875H10.2043ZM11.4543 11.125V10.5H10.8293V11.125H11.4543ZM11.4543 15.875H10.8293V16.5H11.4543V15.875ZM12.5957 15.875V16.5H13.2207V15.875H12.5957ZM12.5957 11.125H13.2207V10.5H12.5957V11.125ZM13.8457 8.125V7.5H13.2207V8.125H13.8457ZM13.8457 9.875H13.2207V10.5H13.8457V9.875ZM23.375 8.125H24V7.5H23.375V8.125ZM23.375 9.875V10.5H24V9.875H23.375ZM10.2043 3H10.8293V1.75H10.2043V3ZM10.8293 3V2.375H9.57926V3H10.8293ZM10.8293 6.875V3H9.57926V6.875H10.8293ZM0 7.5H10.2043V6.25H0V7.5ZM-0.625 7.5H0V6.25H-0.625V7.5ZM0 7.5V6.875H-1.25V7.5H0ZM0 10.5V7.5H-1.25V10.5H0ZM0 11.125V10.5H-1.25V11.125H0ZM0 10.5H-0.625V11.75H0V10.5ZM10.2043 10.5H0V11.75H10.2043V10.5ZM10.8293 16.5V11.125H9.57926V16.5H10.8293ZM10.8293 17.125V16.5H9.57926V17.125H10.8293ZM10.8293 16.5H10.2043V17.75H10.8293V16.5ZM13.2207 16.5H10.8293V17.75H13.2207V16.5ZM13.8457 16.5H13.2207V17.75H13.8457V16.5ZM13.2207 16.5V17.125H14.4707V16.5H13.2207ZM13.2207 11.125V16.5H14.4707V11.125H13.2207ZM24 10.5H13.8457V11.75H24V10.5ZM24.625 10.5H24V11.75H24.625V10.5ZM24 10.5V11.125H25.25V10.5H24ZM24 7.5V10.5H25.25V7.5H24ZM24 6.875V7.5H25.25V6.875H24ZM24 7.5H24.625V6.25H24V7.5ZM13.8457 7.5H24V6.25H13.8457V7.5ZM13.2207 3V6.875H14.4707V3H13.2207ZM13.2207 2.375V3H14.4707V2.375H13.2207ZM13.2207 3H13.8457V1.75H13.2207V3ZM10.8293 3H13.2207V1.75H10.8293V3ZM13.2207 6.875V3.625H11.9707V6.875H13.2207ZM12.5957 3H11.4543V4.25H12.5957V3ZM10.8293 3.625V6.875H12.0793V3.625H10.8293ZM11.4543 7.5H12.5957V6.25H11.4543V7.5ZM12.5957 7.5H11.4543V8.75H12.5957V7.5ZM13.2207 9.875V8.125H11.9707V9.875H13.2207ZM11.4543 10.5H12.5957V9.25H11.4543V10.5ZM10.8293 8.125V9.875H12.0793V8.125H10.8293ZM10.2043 7.5H0.625V8.75H10.2043V7.5ZM0 8.125V9.875H1.25V8.125H0ZM0.625 10.5H10.2043V9.25H0.625V10.5ZM10.8293 9.875V8.125H9.57926V9.875H10.8293ZM10.8293 11.125V15.875H12.0793V11.125H10.8293ZM11.4543 16.5H12.5957V15.25H11.4543V16.5ZM13.2207 15.875V11.125H11.9707V15.875H13.2207ZM12.5957 10.5H11.4543V11.75H12.5957V10.5ZM13.2207 8.125V9.875H14.4707V8.125H13.2207ZM23.375 7.5H13.8457V8.75H23.375V7.5ZM24 9.875V8.125H22.75V9.875H24ZM13.8457 10.5H23.375V9.25H13.8457V10.5Z",
          fill: "white"
        }), /*#__PURE__*/_jsx("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M13.2692 2.00002H10.7308V7.49999H0V10.5H10.7308V17.5H13.2692V10.5H25.5V7.49999H13.2692V2.00002Z",
          fill: "#F50100"
        })]
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.0375 10.95C13.1766 10.95 14.1 10.0266 14.1 8.88747C14.1 7.74838 13.1766 6.82497 12.0375 6.82497C10.8984 6.82497 9.97504 7.74838 9.97504 8.88747C9.97504 10.0266 10.8984 10.95 12.0375 10.95Z",
        fill: "#2E42A5"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 9.51844L11.1016 10.1958L11.445 9.06072L10.5 8.34427L11.6856 8.32011L12.075 7.19997L12.4644 8.32011L13.65 8.34427L12.705 9.06072L13.0484 10.1958L12.075 9.51844Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M5.32501 9.43206L4.51384 9.99652L4.80001 9.05063L4.01251 8.45359L5.00054 8.43345L5.32501 7.5L5.64948 8.43345L6.63751 8.45359L5.85001 9.05063L6.13618 9.99652L5.32501 9.43206Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M18.825 9.43206L18.0138 9.99652L18.3 9.05063L17.5125 8.45359L18.5005 8.43345L18.825 7.5L19.1495 8.43345L20.1375 8.45359L19.35 9.05063L19.6362 9.99652L18.825 9.43206Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 5.83206L11.2638 6.39652L11.55 5.45062L10.7625 4.85358L11.7505 4.83345L12.075 3.89999L12.3995 4.83345L13.3875 4.85358L12.6 5.45062L12.8862 6.39652L12.075 5.83206Z",
        fill: "#FECA00"
      }), /*#__PURE__*/_jsx("path", {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M12.075 13.7821L11.2638 14.3465L11.55 13.4006L10.7625 12.8036L11.7505 12.7835L12.075 11.85L12.3995 12.7835L13.3875 12.8036L12.6 13.4006L12.8862 14.3465L12.075 13.7821Z",
        fill: "#FECA00"
      })]
    })]
  })]
}));
//# sourceMappingURL=Niue.js.map